/**
 * Карточка страницы — скруглённая панель с тенью.
 * Используется для обёртки контента (таблицы, списки и т.д.).
 */
export default function PageCard({ children, className = '' }) {
  return <div className={`page-card ${className}`.trim()}>{children}</div>
}
